module.exports = __webpack_public_path__ + "img/arac-kasko-sigortasi.a59f50c4.svg";